package br.com.vvrefeicoes.portal.core.util.spreadsheet

/**
 * Leitor de CSV/TSV tolerante: detecta o separador (`;` ou `,`), suporta aspas com escape
 * (`""`), quebras CRLF/LF e remove BOM. Sem dependências.
 */
internal object CsvReader {
    fun read(text: String): List<List<String>> {
        val content = text.removePrefix("\uFEFF")
        val delimiter = detectDelimiter(content)
        val rows = ArrayList<List<String>>()
        val row = ArrayList<String>()
        val field = StringBuilder()
        var inQuotes = false
        var index = 0
        while (index < content.length) {
            val char = content[index]
            when {
                inQuotes ->
                    when {
                        char == '"' && index + 1 < content.length && content[index + 1] == '"' -> {
                            field.append('"')
                            index++
                        }
                        char == '"' -> inQuotes = false
                        else -> field.append(char)
                    }
                char == '"' -> inQuotes = true
                char == delimiter -> {
                    row.add(field.toString())
                    field.clear()
                }
                char == '\n' -> {
                    row.add(field.toString())
                    field.clear()
                    rows.add(row.toList())
                    row.clear()
                }
                char == '\r' -> Unit
                else -> field.append(char)
            }
            index++
        }
        if (field.isNotEmpty() || row.isNotEmpty()) {
            row.add(field.toString())
            rows.add(row.toList())
        }
        return rows
    }

    private fun detectDelimiter(text: String): Char {
        val firstLine = text.lineSequence().firstOrNull().orEmpty()
        var commas = 0
        var semicolons = 0
        var inQuotes = false
        for (char in firstLine) {
            when {
                char == '"' -> inQuotes = !inQuotes
                !inQuotes && char == ',' -> commas++
                !inQuotes && char == ';' -> semicolons++
            }
        }
        return if (semicolons > commas) ';' else ','
    }
}
